import { render, staticRenderFns } from "./MainBar.vue?vue&type=template&id=46db4952&scoped=true&"
import script from "./MainBar.vue?vue&type=script&lang=js&"
export * from "./MainBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46db4952",
  null
  
)

export default component.exports